module.exports = __webpack_public_path__ + "media/images/MR_doc-d39210df.png";